var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BaseNav',{attrs:{"nav_text":['Home', 'CatchUp!', 'Schoolwork', 'Report'],"nav_icon":[
      'icon-feeds',
      'icon-book-pile',
      'icon-library',
      'icon-pie-chart' ],"nav_name":[
      'StudentFeeds',
      'StudentFalseCatchup',
      'StudentHomework',
      'StudentFalseReport' ],"nav_type":"student","show_nav":true}}),_c('MobileTopNav',{attrs:{"nav_type":"student"}}),_c('MobileBaseNav',{attrs:{"nav_text":['Home', 'CatchUp!', 'Schoolwork', 'Report'],"nav_icon":[
      'icon-feeds',
      'icon-book-pile',
      'icon-library',
      'icon-pie-chart' ],"nav_name":[
      'StudentFeeds',
      'StudentFalseCatchup',
      'StudentHomework',
      'StudentFalseReport' ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }